import { createMemo, createSignal, onMount, useContext } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ListItemSwitchPropsType } from '~/types/ListItemSwitch'
import { ListContext } from './List'
import ListItem from './ListItem'
import ListItemText from './ListItemText'
import Switch from './Switch'

export default function ListItemSwitch(props: ListItemSwitchPropsType) {
  const listContext = useContext(ListContext)
  const isControlled = () => props.checked !== undefined && props.onChange !== undefined
  const [internalChecked, setInternalChecked] = createSignal(props.checked || false)

  onMount(() => {
    if (props.checked !== undefined) {
      setInternalChecked(props.checked)
    }

    if (!isControlled() && listContext.setSelectedValue) {
      listContext.setSelectedValue(props.name, props.value, internalChecked())
    }
  })

  const handleChange = (event: Event & { currentTarget: HTMLInputElement; target: HTMLInputElement }) => {
    const isChecked = event.target.checked

    if (!isControlled()) {
      setInternalChecked(isChecked)

      if (listContext.setSelectedValue) {
        listContext.setSelectedValue(props.name, props.value, isChecked)
      }
    }

    if (props.onChange) {
      props.onChange(isChecked)
    }
  }

  const checked = () => (isControlled() ? props.checked! : internalChecked())

  const containerClasses = createMemo(() => twMerge('flex items-center justify-between w-full', props.class))

  if (props.secondary) {
    return (
      <ListItem class={containerClasses()} classList={props.classList} disabled={props.disabled}>
        <ListItemText primary={props.label} />
        <Switch checked={checked()} onChange={handleChange} disabled={props.disabled} />
      </ListItem>
    )
  }

  return (
    <ListItem class={containerClasses()} classList={props.classList} disabled={props.disabled}>
      <Switch checked={checked()} onChange={handleChange} disabled={props.disabled} />
      <ListItemText primary={props.label} />
    </ListItem>
  )
}
